import { createContext } from "react";

const AdministrativelDaysContext = createContext();

export default AdministrativelDaysContext;